import { render, staticRenderFns } from "./hero-select.vue?vue&type=template&id=29c12a9c&scoped=true&"
import script from "./hero-select.vue?vue&type=script&lang=ts&"
export * from "./hero-select.vue?vue&type=script&lang=ts&"
import style0 from "./hero-select.vue?vue&type=style&index=0&id=29c12a9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c12a9c",
  null
  
)

export default component.exports